import React from 'react';

function SmallDetailedCard({
  categoryField, onSeriesClick,
  heading, content, rawContent,
}) {
  return (
    <div
      className="dashboard__samll-display-card round-border"
      style={{ height: '85px', position: 'relative' }}
      onClick={() => onSeriesClick({ categoryField, value: heading })}
    >
      <div className="dashboard_samll-detail-card">

        <div className="dashboard_samll-detail-card-header">
          <span style={{ float: 'left' }} title={heading}>
            {heading}
          </span>
        </div>
        <div className="dashboard_samll-detail-card-content" title={rawContent}>
          {content}
        </div>
      </div>
    </div>
  );
}

export default SmallDetailedCard;
